module.exports = __webpack_public_path__ + "img/service-jiaoyicuohe2.ded81c50.svg";